import React from "react";

export default function NumberDisplay() {
	return <div>Display for Number Input?</div>;
}